import React from "react";
import UserTag from "../../shared/UserTag";
import FollowButton from "../FollowButton";

export default ({ user }) => {
  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <UserTag user={user} className="text-light" />
        <FollowButton user={user} varient="primary" />
      </div>
      <h6 className="text-light mt-2">
        <i>{user.status}</i>
      </h6>
    </div>
  );
};
